import request from "@/utils/request";
// 体感游戏列表
const getGameList = (params) =>
  request.post("/laiHi/web/sportGame/pageQuerySportsGame", params);
// 添加或修改体感游戏
const setGame = (params) =>
  request.post("/laiHi/web/sportGame/addModifySportsGame", params);
// 获取游戏教程列表
const getTutorialList = (params) =>
  request.post("/laiHi/web/gameTutorial/queryGameTutorialList", params);
// 设置游戏教程
const setGameTutorial = (params) =>
  request.post("/laiHi/web/gameTutorial/setGameTutorial", params);
// 删除游戏教程
const deleteGameTutorial = (params) =>
  request.post("/laiHi/web/gameTutorial/deleteGameTutorial", params);
// 查询所有体感游戏列表
const getAllSportsGameList = () =>
  request.post("/laiHi/web/sportGame/querySportsGameList");
export {
  getGameList,
  setGame,
  getTutorialList,
  setGameTutorial,
  deleteGameTutorial,
  getAllSportsGameList,
};
